module.exports = __webpack_public_path__ + "static/media/nagano.1d39c32d.png";